import Modal from '../../../../node_modules/bootstrap/js/src/modal'
import youtube from './youtube'

const modalVideo = {
  playerModal: '',
  elModal: '',
  elBtns: '',
  init() {
    this.elBtns = $q('.block-carousel [data-video]')
    this.elModal = $q('#ytplayer-modal')

    if (!this.elBtns.first) return

    this.buildModal()
  },
  buildModal() {
    if (!this.elModal.first) return

    this.playerModal = new Modal(this.elModal.first)

    youtube.elBtns = this.elBtns
    youtube.onClick = () => this.playerModal.show()
    youtube.init()

    this.elModal.first.addEventListener('hidden.bs.modal', () => {
      if (youtube.player) youtube.player.destroy()
    })
  }
}
export default modalVideo
